import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ScrollToTop } from './src/components/shared/ScrollToTop';
import { AuthProvider } from './src/context/AuthContext';
// Layouts
import { PublicLayout } from './src/components/layout/PublicLayout';
import { DashboardLayout } from './src/components/layout/DashboardLayout';
import { AdminLayout } from './src/components/layout/AdminLayout';
// Public Pages
import { Home } from './src/pages/Home';
import { Explore } from './src/pages/Explore';
import { PropertyDetail } from './src/pages/PropertyDetail';
import { About } from './src/pages/About';
import { Contact } from './src/pages/Contact';
import { MapDiscovery } from './src/pages/MapDiscovery';
import { Compare } from './src/pages/Compare';
// Auth & Payment
import { Login } from './src/pages/auth/Login';
import { Register } from './src/pages/auth/Register';
import { ForgotPassword } from './src/pages/auth/ForgotPassword';
import { VerifyOtp } from './src/pages/auth/VerifyOtp';
import { ListProperty } from './src/pages/seller/ListProperty';
import { Checkout } from './src/pages/payment/Checkout';
import { PaymentSuccess } from './src/pages/payment/PaymentSuccess';
// Dashboard Pages
import { BuyerDashboard } from './src/pages/dashboard/BuyerDashboard';
import { SavedProperties } from './src/pages/dashboard/buyer/SavedProperties';
import { Inspections } from './src/pages/dashboard/buyer/Inspections';
import { Messages } from './src/pages/dashboard/buyer/Messages';
import { SellerDashboard } from './src/pages/dashboard/SellerDashboard';
import { SellerListings } from './src/pages/dashboard/seller/SellerListings';
import { SellerAnalytics } from './src/pages/dashboard/seller/SellerAnalytics';
import { Inquiries } from './src/pages/dashboard/seller/Inquiries';
import { Settings } from './src/pages/dashboard/Settings';
// Admin Pages
import { AdminLogin } from './src/pages/admin/AdminLogin';
import { AdminDashboard } from './src/pages/admin/AdminDashboard';
import { VerificationManagement } from './src/pages/admin/VerificationManagement';
import { FraudDetection } from './src/pages/admin/FraudDetection';
import { ListingManagement } from './src/pages/admin/ListingManagement';
import { UserManagement } from './src/pages/admin/UserManagement';
import { Finance } from './src/pages/admin/Finance';
import { AdminSettings } from './src/pages/admin/AdminSettings';
import { InspectionManagement } from './src/pages/admin/InspectionManagement';
import { MessagingModeration } from './src/pages/admin/MessagingModeration';
import { ReportsAnalytics } from './src/pages/admin/ReportsAnalytics';
import { CmsManagement } from './src/pages/admin/CmsManagement';
import { NotificationManagement } from './src/pages/admin/NotificationManagement';
import { AdminProfile } from './src/pages/admin/AdminProfile';
export function App() {
  useEffect(() => {
    document.title = 'Nigerians Verified Properties';
  }, []);
  return <BrowserRouter data-id="element-0">
      <AuthProvider data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          {/* Public Routes */}
          <Route element={<PublicLayout data-id="element-5" />} data-id="element-4">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/explore" element={<Explore data-id="element-9" />} data-id="element-8" />
            <Route path="/property/:id" element={<PropertyDetail data-id="element-11" />} data-id="element-10" />
            <Route path="/map" element={<MapDiscovery data-id="element-13" />} data-id="element-12" />
            <Route path="/about" element={<About data-id="element-15" />} data-id="element-14" />
            <Route path="/contact" element={<Contact data-id="element-17" />} data-id="element-16" />
            <Route path="/compare" element={<Compare data-id="element-19" />} data-id="element-18" />
          </Route>

          {/* Auth & Onboarding & Payment (No Layout) */}
          <Route path="/login" element={<Login data-id="element-21" />} data-id="element-20" />
          <Route path="/register" element={<Register data-id="element-23" />} data-id="element-22" />
          <Route path="/forgot-password" element={<ForgotPassword data-id="element-25" />} data-id="element-24" />
          <Route path="/verify-otp" element={<VerifyOtp data-id="element-27" />} data-id="element-26" />
          <Route path="/list-property" element={<ListProperty data-id="element-29" />} data-id="element-28" />
          <Route path="/checkout" element={<Checkout data-id="element-31" />} data-id="element-30" />
          <Route path="/payment-success" element={<PaymentSuccess data-id="element-33" />} data-id="element-32" />

          {/* Buyer Dashboard */}
          <Route path="/dashboard/buyer" element={<DashboardLayout type="buyer" data-id="element-35" />} data-id="element-34">
            <Route index element={<BuyerDashboard data-id="element-37" />} data-id="element-36" />
            <Route path="saved" element={<SavedProperties data-id="element-39" />} data-id="element-38" />
            <Route path="inspections" element={<Inspections data-id="element-41" />} data-id="element-40" />
            <Route path="messages" element={<Messages data-id="element-43" />} data-id="element-42" />
            <Route path="settings" element={<Settings type="buyer" data-id="element-45" />} data-id="element-44" />
            <Route path="*" element={<Navigate to="/dashboard/buyer" replace data-id="element-47" />} data-id="element-46" />
          </Route>

          {/* Seller Dashboard */}
          <Route path="/dashboard/seller" element={<DashboardLayout type="seller" data-id="element-49" />} data-id="element-48">
            <Route index element={<SellerDashboard data-id="element-51" />} data-id="element-50" />
            <Route path="listings" element={<SellerListings data-id="element-53" />} data-id="element-52" />
            <Route path="analytics" element={<SellerAnalytics data-id="element-55" />} data-id="element-54" />
            <Route path="inquiries" element={<Inquiries data-id="element-57" />} data-id="element-56" />
            <Route path="settings" element={<Settings type="seller" data-id="element-59" />} data-id="element-58" />
            <Route path="*" element={<Navigate to="/dashboard/seller" replace data-id="element-61" />} data-id="element-60" />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin data-id="element-63" />} data-id="element-62" />
          <Route path="/admin" element={<AdminLayout data-id="element-65" />} data-id="element-64">
            <Route index element={<AdminDashboard data-id="element-67" />} data-id="element-66" />
            <Route path="verification" element={<VerificationManagement data-id="element-69" />} data-id="element-68" />
            <Route path="fraud" element={<FraudDetection data-id="element-71" />} data-id="element-70" />
            <Route path="listings" element={<ListingManagement data-id="element-73" />} data-id="element-72" />
            <Route path="users" element={<UserManagement data-id="element-75" />} data-id="element-74" />
            <Route path="finance" element={<Finance data-id="element-77" />} data-id="element-76" />
            <Route path="inspections" element={<InspectionManagement data-id="element-79" />} data-id="element-78" />
            <Route path="messaging" element={<MessagingModeration data-id="element-81" />} data-id="element-80" />
            <Route path="analytics" element={<ReportsAnalytics data-id="element-83" />} data-id="element-82" />
            <Route path="cms" element={<CmsManagement data-id="element-85" />} data-id="element-84" />
            <Route path="notifications" element={<NotificationManagement data-id="element-87" />} data-id="element-86" />
            <Route path="settings" element={<AdminSettings data-id="element-89" />} data-id="element-88" />
            <Route path="profile" element={<AdminProfile data-id="element-91" />} data-id="element-90" />
            <Route path="*" element={<Navigate to="/admin" replace data-id="element-93" />} data-id="element-92" />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-95" />} data-id="element-94" />
        </Routes>
      </AuthProvider>
    </BrowserRouter>;
}